import { personalRoutes } from './routes/personalRoutes.tsx';
import { businessRoutes } from './routes/buisnessRoutes.tsx';
import { yellowLaneRoutes } from './routes/yellowLaneRoutes.tsx';
import { finishingRoutes } from './routes/finishingRoutes.tsx';
import { rootRoute } from './routes/rootRoute.tsx';
import { ownerRoutes } from './routes/ownerRoutes.tsx';
import { inviteTeamMemberRoutes } from './routes/inviteTeamMemberRoutes.tsx';
import { recoveryRoutes } from './routes/recoveryRoutes.tsx';
import { authRoutes } from './routes/authRoutes.tsx';
import { uboOnboardingRoutes } from './routes/uboOnboardingRoutes.tsx';
import { eddRoutes } from './routes/eddRoutes.tsx';
import { cddRoutes } from './routes/cddRoutes.tsx';

export const routeTree = rootRoute.addChildren([
  ...finishingRoutes,
  ...yellowLaneRoutes,
  ...businessRoutes,
  ...personalRoutes,
  ...ownerRoutes,
  ...inviteTeamMemberRoutes,
  ...recoveryRoutes,
  ...authRoutes,
  ...uboOnboardingRoutes,
  ...eddRoutes,
  ...cddRoutes,
]);
